import React from "react";
import { Clearfix } from "react-bootstrap";
import { Banner, EmptyBanner } from "../../stores/BannerStore";
import { PageType, TargetParams } from "../../utils/BannerContainer";
import { trackArticleBannerClick, trackArticleBannerSponsoredClick } from "../../utils/BannerTrackingUtil";
import { wrapLazy } from "../LazyWrapper";
import { isEmptyBanner } from "../../utils/BannerUtil";
const ArticleBannerCard = wrapLazy(React.lazy(() => import("explore_ui/ArticleBannerCard")));

type PropType = {
    banner: Banner | EmptyBanner;
    targetParams: TargetParams | null | undefined;
    pageType: PageType;
};

class ArticlesBanner extends React.Component<PropType> {
    constructor(props: PropType) {
        super(props);

        this.trackClick = this.trackClick.bind(this);
        this.trackSponsoredClick = this.trackSponsoredClick.bind(this);
    }

    trackClick(banner: Banner, targetingParams: TargetParams, articleId: string) {
        trackArticleBannerClick(banner, this.props.pageType, articleId, targetingParams);
    }

    trackSponsoredClick(banner: Banner, targetingParams: TargetParams, articleId: string) {
        trackArticleBannerSponsoredClick(banner, this.props.pageType, articleId, targetingParams);
    }

    renderArticles(banner: Banner): Array<Object> {
        const articleData = banner.articleData ? banner.articleData : [];
        return this.props.targetParams
            ? articleData
                  .filter(article => article !== null)
                  .map(article => (
                      <ArticleBannerCard
                          bannerArticle={article}
                          banner={banner}
                          targetingParams={this.props.targetParams}
                          bannerClickTracking={this.trackClick}
                          sponsoredLinkClickTracking={this.trackSponsoredClick}
                      />
                  ))
            : [];
    }

    render() {
        const banner = this.props.banner;
        if (isEmptyBanner(banner)) {
            return null;
        }
        const renderedArticles = this.renderArticles(banner as Banner);
        // render banners with minimum 2 articles
        if (renderedArticles.length > 1) {
            const className: string =
                renderedArticles.length === 2 ? "mfcss-article-banner-2-items" : "mfcss-article-banner";
            return (
                <React.Fragment>
                    <div className={className}>{renderedArticles}</div>
                    <Clearfix />
                </React.Fragment>
            );
        }
        return null;
    }
}

export default ArticlesBanner;
